import * as graphql from '@treams/treams-network';
import { Container, FlexGap, tokens } from '@treams/treams-ui';

import UserDocuments from '../packages/kakapo-ui-application/pages/users/UserDocuments';
import UserDownloads from '../packages/kakapo-ui-application/pages/users/UserDownloads';

export default function PersonalFiles(props: { userID: string }) {
	const query = graphql.useUserQuery({ variables: { id: props.userID } });

	if (!query.data) {
		return null;
	}

	return (
		<Container pt={`${tokens.gap.page}px`} pb={4}>
			<FlexGap flexDirection="column" gap={tokens.gap.section}>
				<UserDocuments user={query.data.user as graphql.User} />
				<UserDownloads user={query.data.user as graphql.User} />
			</FlexGap>
		</Container>
	);
}
